import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';

import { filter, first, map } from 'rxjs/operators';

import { AuthStore } from '../store/auth.store';
import { LoadingCoordinatorService } from '../services/loading/loading-coordinator.service';
import { LoggerService } from '../services/logger/logger.service';
import { UserStore } from '../store/user.store';

const LOG_OPTIONS = { when: ['debugGuards'] as const };

export const userLoadedGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const authStore = inject(AuthStore);
  const loadingCoordinator = inject(LoadingCoordinatorService);
  const logger = inject(LoggerService);

  console.log('[UserLoadedGuard] ========== GUARD CHECK ==========');
  console.log('[UserLoadedGuard] Current URL:', window.location.href);

  logger.log('[UserLoadedGuard] Checking user status', LOG_OPTIONS);

  const isAuthenticated = authStore.isAuthenticated();
  console.log('[UserLoadedGuard] authStore.isAuthenticated():', isAuthenticated);

  if (!isAuthenticated) {
    console.log('[UserLoadedGuard] Not authenticated, skipping user load (returning true)');
    logger.log('[UserLoadedGuard] Not authenticated, skipping', LOG_OPTIONS);
    return true;
  }

  const currentUser = userStore.currentUser();
  const isLoading = userStore.loading();
  console.log('[UserLoadedGuard] currentUser:', currentUser ? 'present' : 'null');
  console.log('[UserLoadedGuard] isLoading:', isLoading);

  if (currentUser) {
    console.log('[UserLoadedGuard] ✅ User already loaded');
    logger.log('[UserLoadedGuard] User already loaded', LOG_OPTIONS);
    return true;
  }

  if (!isLoading) {
    console.log('[UserLoadedGuard] User not loaded and not loading, triggering load...');
    logger.log('[UserLoadedGuard] User not loaded and not loading, triggering load', LOG_OPTIONS);
    loadingCoordinator.setMeCallStart();
    userStore.loadCurrentUser();
  } else {
    console.log('[UserLoadedGuard] User loading in progress, waiting...');
    logger.log('[UserLoadedGuard] User loading in progress...', LOG_OPTIONS);
  }

  console.log('[UserLoadedGuard] Returning observable - will wait for user to load');
  return toObservable(userStore.currentUser).pipe(
    filter(user => user !== null),
    first(),
    map(() => {
      console.log('[UserLoadedGuard] ✅ User loaded successfully via observable');
      logger.log('[UserLoadedGuard] User loaded successfully', LOG_OPTIONS);
      return true;
    })
  );
};
